import { config } from "../../../../config";
import { isGrowth24PlanEnabled, planChargeInDollars } from "../../../common";
import { CUSTOM_FIELDS_DEV_FEAT_KEY } from "../../../common/constants";
import { PlanFeatures } from "./ExplorePlans/constants/constants";

export const createNewPlan = ({
  planName,
  bullets,
  features,
  valueServices,
  displayName = null,
  isOld = false,
}) => {
  return {
    title: planName,
    displayName,
    cta: 'Upgrade',
    showPricingDetails: true,
    color: '#4289ff',
    highlight: false,
    showCTA: true,
    old: isOld,
    currentPlan: false,
    pricing: { annual: {}, monthly: {} },
    pricingKeys: [],
    bulletsUpdated: false,
    bullets,
    features,
    valueServices,
  };
};

const Lite24_BULLETS = [
  { value: 'Everything in Free and', addOnFeatures: 5 }, // addonFeatures represent no. of features which are removed from top of this array when plan features are falttened out.
  { isUnlimited: false, count: 2, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
  { isUnlimited: false, count: 10, value: PlanFeatures.AUTOMATIONS, hasTooltip: true  },
  { isUnlimited: false, count: 1, value: PlanFeatures.SLA_REMINDERS, hasTooltip: false },
  { isUnlimited: false, count: 2, value: PlanFeatures.CUSTOM_FIELDS_PER_MAILBOX, hasTooltip: false, releaseFeatureFlag: CUSTOM_FIELDS_DEV_FEAT_KEY },
  { isUnlimited: false, value: PlanFeatures.ROUND_ROBIN_AUTO_ASSIGNMENT, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.CONVERSATION_REPORTS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.KNOWLEDGE_BASE, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.A_J_S_Q_INTEGRATIONS },
  { isUnlimited: false, value: PlanFeatures.ONBOARDING_ASSISTANCE, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.CHAT_TRANSCIPTS, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.ARTICLES_IN_CHAT, hasTooltip: false},
  { isUnlimited: false, value: PlanFeatures.INTERNAL_KNOWLEDGE_BASE, hasTooltip: false},
];

const FREE_BULLETS = [
  { value: 'Includes', addOnFeatures: 4 }, // addonFeatures represent no. of features which are removed from top of this array when plan features are falttened out.
  { isUnlimited: false, count: 1, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
  { isUnlimited: true, value: PlanFeatures.USERS, hasTooltip: false  },
  { isUnlimited: false, value: PlanFeatures.SUPPORT, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.KNOWLEDGE_BASE_WITH_ARTICLE_LIMIT, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.EMAIL_MANAGEMENT, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.MULTI_CHANNEL_ENGAGEMENT, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.TEAM_COLLABORATION, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.SHAREABLE_PERMALINKS, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.SLACK_INTEGRATION, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.DEFAULT_USER_ROLES, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.IOS_ANDROID_APPS, hasTooltip: false },
];

const GROWTH_24_BULLETS = [
  { value: 'Everything in Lite and', addOnFeatures: 6 }, // addonFeatures represent no. of features which are removed from top of this array when plan features are falttened out.
  { isUnlimited: false, count: 3, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
  { isUnlimited: false, count: 15, value: PlanFeatures.AUTOMATIONS, hasTooltip: true},
  { isUnlimited: false, count: 2, value: PlanFeatures.SLA_REMINDER_PLURAL, hasTooltip: false },
  { isUnlimited: false, count: 5, value: PlanFeatures.CUSTOM_FIELDS_PER_MAILBOX, hasTooltip: false, releaseFeatureFlag: CUSTOM_FIELDS_DEV_FEAT_KEY },
  { isUnlimited: false, value: PlanFeatures.ZAPIER_INTEGRATION, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.ADVANCED_ANALYTIC_REPORT, hasTooltip: true },
]

const PRO_24_BULLETS  =  [
  { value: 'Everything in Lite and', addOnFeatures: 4 },
  { isUnlimited: false, count: 5, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
  { isUnlimited: false, count: 10, value: PlanFeatures.CUSTOM_FIELDS_PER_MAILBOX, hasTooltip: false, releaseFeatureFlag: CUSTOM_FIELDS_DEV_FEAT_KEY },
  { isUnlimited: false, count: 20, value: PlanFeatures.AUTOMATIONS, hasTooltip: true},
  { isUnlimited: true,  value: PlanFeatures.SLA_REMINDER_PLURAL, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.R_R_AUTO_ASSIGNMENT, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.CSAT_SURVEY, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.ADVANCED_ANALYTIC_REPORT, hasTooltip: true }, //TODO: remove this after Growth24 plan rls-2024-growth-plan is GA
  { isUnlimited: false, value: PlanFeatures.SLA_BUSINESS_HOURS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.HARVEY_AI_BOT, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.AI_SUMMARIZER, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.API_ACCESS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.SALESFORCE_ZAPIER },
  { isUnlimited: false, value: PlanFeatures.CHATBOTS, hasTooltip: true },
]

const ELITE_24_BULLETS = [
  { value: 'Everything in Pro and' , addOnFeatures: 3},
  { isUnlimited: true, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
  { isUnlimited: true, value: PlanFeatures.CUSTOM_FIELDS, hasTooltip: false, releaseFeatureFlag: CUSTOM_FIELDS_DEV_FEAT_KEY },
  { isUnlimited: true, value: PlanFeatures.AUTOMATIONS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.SKILL_BASED_ASSIGNMENTS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.OKTA_INTEGRATION, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.HIPAA_COMPLIANCE, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.CUSTOM_BUILD_HOURS, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.CALL_BACK_SUPPORT, hasTooltip: false },
  { isUnlimited: false, value: PlanFeatures.DEDICATED_SUCCESS_MANAGER, hasTooltip: true },
  { isUnlimited: false, value: PlanFeatures.QUATERLY_TRAININGS, hasTooltip: true }
]



export const OLD_LITE24_PLANIDS = [1700, 1701];

export const PlansDetails = {

  /* ----------- 2023 Plans Feature List ----------- */
  Lite_23: {
    planName: 'Lite_23',
    displayName: 'Lite',
    bullets: isExplorePlanEnabled => isExplorePlanEnabled ? (
    [
      { value: 'Includes' ,addOnFeatures: 3},
      { isUnlimited: false, count: 2, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
      { isUnlimited: false, value: 'Add upto 10 Users', hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.DEFAULT_USER_ROLES, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.LIVE_CHAT, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.WHATSAPP_MESSAGING, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.KNOWLEDGE_BASE, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SHARED_CONTACTS_COMPANIES, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.EMAIL_MANAGEMENT, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.TEAM_COLLABORATION, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SHAREABLE_PERMALINKS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.IOS_ANDROID_APPS, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.ONBOARDING_ASSISTANCE, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.CHAT_EMAIL_SUPPORT, hasTooltip: false },
    ]) : (
    [
      { isUnlimited: false, count: 2, value: 'Shared Mailboxes' },
      { isUnlimited: true, value: 'Tags' },
      { isUnlimited: false, count: 1, value: 'Alias per Shared Inbox' },
      { isUnlimited: true, value: ' Email Templates' },
      { isUnlimited: false, value: 'Private Views' },
      { isUnlimited: false, value: 'Add upto 10 Users' },
      { isUnlimited: false, value: 'Conversation ID' },
      { isUnlimited: false, value: 'Live Chat' },
      { isUnlimited: false, value: 'Knowledge Base' },
      { isUnlimited: false, value: 'WhatsApp channel' },
      { isUnlimited: false, value: 'Contacts' },
      { isUnlimited: false, value: 'Shared Drafts' },
      { isUnlimited: false, value: 'Email Notes' },
      { isUnlimited: false, value: 'Collision Alerts' },
      { isUnlimited: false, value: 'Collaborators' },
      { isUnlimited: false, value: 'Approvals' },
      { isUnlimited: false, value: 'Permalinks' },
      {
        isUnlimited: false,
        value: 'Default Access Control',
        tooltip: 'Includes 2 Default Roles',
      },
      { isUnlimited: false, value: 'IOS & Android Mobile Apps' },
      { isUnlimited: false, value: 'Onboarding Assistance' },
      { isUnlimited: false, value: '24x7 Chat & Email Support' },
    ]),
    features: [],
    valueServices: [],
  },
  Pro_23: {
    planName: 'Pro_23',
    displayName: 'Pro',
    bullets: isExplorePlanEnabled => isExplorePlanEnabled ? (
    [
      { value: 'Everything in Lite and' ,addOnFeatures: 1},
      { isUnlimited: false, count: 5, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
      { isUnlimited: true, value: 'Users', hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.VOICE_INBOXES_DIALER, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SHARED_VIEWS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.WORKLOAD_DISTRIBUTION, hasTooltip: true },
      { inUnlimited: false, value: PlanFeatures.RULE_BASED_AUTOMATIONS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SLA_BUSINESS_HOURS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.REPORTS_DASHBOARDS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.ADVANCED_LIVE_CHAT_CONTROLS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.OUT_BOX_INTEGRATIONS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.ADVANCED_USER_ROLES, hasTooltip: true },
    ]) : (
    [
      { isBold: true, value: 'Everything in Lite and' },
      { isUnlimited: true, count: 5, value: 'Shared Mailboxes' },
      { isUnlimited: true, value: 'Users' },
      { isUnlimited: false, value: 'Chatbots' },
      { isUnlimited: true, value: 'Shared Inbox Aliases' },
      { isUnlimited: false, value: 'Basic Automations' },
      { isUnlimited: false, value: 'Shared and Private Views' },
      {
        isUnlimited: false,
        value: 'Voice Channel',
        tooltip: 'Log and manage voice calls and voicemails inside Gmail using Aircall'
      },
      {
        isUnlimited: false,
        value: 'SLA Violations & Business Hours',
      },
      { isUnlimited: false, value: 'SLA Reports' },
      { isUnlimited: false, value: 'Live Chat CSAT' },
      { isUnlimited: false, value: 'Email CSAT' },
      { isUnlimited: false, value: 'Analytics' },
      {
        isUnlimited: false,
        value: 'Advanced Access Control',
        tooltip: 'Includes 4 default roles',
      },
      { isUnlimited: false, value: 'Asana Integration' },
      { isUnlimited: false, value: 'JIRA Integration' },
      { isUnlimited: false, value: 'Salesforce Integration' },
      { isUnlimited: false, value: 'Zapier Integration' },
      { isUnlimited: false, value: 'QuickBooks Integration' },
      {
        isUnlimited: false,
        value: 'Removed Conversations Log',
        tooltip: 'Track conversations that are deleted from the shared mailbox',
      },
      { isUnlimited: false, value: 'Workload Distribution' },
    ]),
    features: [],
    valueServices: [],
  },
  Elite_23: {
    planName: 'Elite_23',
    displayName: 'Elite',
    bullets: isExplorePlanEnabled => isExplorePlanEnabled ? (
    [
      { value: 'Everything in Pro and',addOnFeatures: 1},
      { isUnlimited: true, value: PlanFeatures.SHARED_MAILBOXES, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.TIME_BASED_AUTOMATIONS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SLA_REMINDERS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.R_R_AUTO_ASSIGNMENT, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.SKILL_BASED_ASSIGNMENTS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.CUSTOM_REPORTS_DASHBOARDS, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.HARVEY_AI_BOT, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.OKTA_INTEGRATION, hasTooltip: true },
      { isUnlimited: false, value: PlanFeatures.HIPAA_COMPLIANCE, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.PRIORITY_SUPPORT, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.CALL_BACK_SUPPORT, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.UPTIME_SLA, hasTooltip: false },
      { isUnlimited: false, value: PlanFeatures.DEDICATED_SUCCESS_MANAGER, hasTooltip: false },
    ]) : (
    [
      { isBold: true, value: 'Everything in Pro and' },
      { isUnlimited: true, value: 'Shared Email Inboxes' },
      { isUnlimited: false, value: 'SLA Reminders' },
      { isUnlimited: false, value: 'Advanced Automations' },
      { isUnlimited: false, value: 'Skill-based Auto-assignment' },
      { isUnlimited: false, value: 'Round Robin Assignment' },
      {
        isUnlimited: false,
        value: 'Custom Access Control',
        tooltip: 'Includes 4 default roles and custom roles',
      },
      { isUnlimited: false, value: 'Custom Reports' },
      { isUnlimited: false, value: 'Custom Dashboards' },
      { isUnlimited: false, value: 'Okta Integration' },
      { isUnlimited: false, value: 'HIPAA Compliance' },
      { isUnlimited: false, value: 'Priority Support' },
      { isUnlimited: false, value: 'Book a call with Hiver support' },
      { isUnlimited: false, value: 'Uptime SLA' },
      { isUnlimited: false, value: 'Dedicated Success Manager' },
      { isUnlimited: false, value: 'Harvey - The AI Bot' },
      { isUnlimited: false, value: 'Scheduled Data Exports' },
    ]),
    features: [],
    valueServices: [],
  },  

  /* ----------- 2024 Plans Feature List ----------- */
  Lite_24: {
    planName: 'Lite_24',
    displayName: 'Lite',
    bullets: Lite24_BULLETS,
    features: [],
    valueServices: [],
  },
  Lite_24_v2: {
    planName: 'Lite_24_v2',
    displayName: 'Lite',
    bullets: Lite24_BULLETS,
    features: [],
    valueServices: [],
  },
  Pro_24: {
    planName: 'Pro_24',
    displayName: 'Pro',
    bullets: PRO_24_BULLETS,
    features: [],
    valueServices: [],
  },
  Elite_24: {
    planName: 'Elite_24',
    displayName: 'Elite',
    bullets: ELITE_24_BULLETS,
    features: [],
    valueServices: [],
  },
  Free: {
    planName: 'Freemium',
    displayName: 'Free',
    bullets: FREE_BULLETS,
    features: [],
    valueServices: [],
  },
  Growth_24: {
    planName: 'Growth_24',
    displayName: 'Growth',
    bullets: GROWTH_24_BULLETS,
    features: [],
    valueServices: [],
  },

  // <<------------- 2025 Tiered Pricing List ---------->>
  Lite_tiered_25: {
    planName: 'Lite_tiered_25',
    displayName: 'Lite',
    bullets: Lite24_BULLETS,
    features: [],
    valueServices: [],
  },
  Growth_tiered_25: {
    planName: 'Growth_tiered_25',
    displayName: 'Growth',
    bullets: GROWTH_24_BULLETS,
    features: [],
    valueServices: [],
  },
  Pro_tiered_25: {
    planName: 'Pro_tiered_25',
    displayName: 'Pro',
    bullets: PRO_24_BULLETS,
    features: [],
    valueServices: [],
  },
  Elite_tiered_25: {
    planName: 'Elite_tiered_25',
    displayName: 'Elite',
    bullets: ELITE_24_BULLETS,
    features: [],
    valueServices: [],
  },
};

export const getUpdatedPlanDetails = (availableFeatures) => {
  if(isGrowth24PlanEnabled(availableFeatures)){
    // TODO: hardcode this value inside feature list after plan is GA
    PlansDetails.Pro_24.bullets[0].value = "Everything in Growth and";
    // TODO: Remove this hardcoded check after Growth24 plan rls-2024-growth-plan is GA , it is required for flattening out plan feature list
    PlansDetails.Pro_24.bullets.splice(7, 1); // 7 is index of ADVANCED_ANALYTIC_REPORT 
  }
  return PlansDetails;
}

const createFilteredPlans = () => {
  const planNames = {
    Lite21: 'Lite_21',
    Growth21: 'Growth_21',
    Pro21: 'Pro_21',
    Elite21: 'Elite_21',
    Lite22: 'Lite_22',
    Pro22: 'Pro_22',
    Elite22: 'Elite_22',
    Lite23: 'Lite_23',
    Pro23: 'Pro_23',
    Elite23: 'Elite_23',
    Lite24: 'Lite_24',
    Lite24V2: 'Lite_24_v2',
    Pro24: 'Pro_24',
    Elite24: 'Elite_24',
    FREEMIUM: 'Freemium', 
    Growth24: 'Growth_24', 
    LiteTiered25:'Lite_tiered_25',
    GrowthTiered25:'Growth_tiered_25',
    ProTiered25:'Pro_tiered_25',
    EliteTiered25:'Elite_tiered_25',
  };


  return ({ currentPlanName, period, isBilling24Enabled, isBilling24V2Enabled,isTieredPricingEnabled }) => {
    const isAnnual = period === 'annual';
    const { Lite21, Growth21, Pro21, Elite21, Lite22, Pro22, Elite22,
            Lite23, Pro23, Elite23, Lite24, Lite24V2, Pro24, Elite24, FREEMIUM, Growth24,LiteTiered25,
            GrowthTiered25,ProTiered25,EliteTiered25} = planNames;

    switch (currentPlanName) {
      case 'Lite':
        return isBilling24Enabled ? [] : [Lite21, Growth21, Pro21, Elite21];
      case 'Growth':
        return isBilling24Enabled ? [] : [Growth21, Pro21, Elite21];
      case 'Pro':
        return isBilling24Enabled ? [] : [Pro21, Elite21];
      case 'Elite':
        return isBilling24Enabled ? [] : [Elite21];
      case Lite21:
        return isBilling24Enabled ? [] : [Lite23, Pro23, Elite23];
      case Growth21:
      case Pro21:
        return isBilling24Enabled ? [] : [Pro23, Elite23]
      case Elite21:
        return isBilling24Enabled ? [] : [Elite23]
      case Pro22:
      case Pro23:
        return isBilling24Enabled ? [Pro24, Elite24] : [Pro23, Elite23]
      case Elite22:
      case Elite23:
        return isBilling24Enabled ? [Elite24] : [Elite23]
      case Lite24:
        return isAnnual ? [Growth24, Pro24, Elite24] : [Lite24, Growth24, Pro24, Elite24]
      case Lite24V2:
        return isAnnual ? [Growth24, Pro24, Elite24] : [Lite24V2, Growth24, Pro24, Elite24]
      case Growth24:
        return isAnnual ? [Pro24, Elite24] : [Growth24, Pro24, Elite24]
      case Pro24:
        return isAnnual ? [Elite24] : [Pro24, Elite24]
      case Elite24:
        return isAnnual ? [] : [Elite24]
      // This tieredPricing cases would only come  when feature-flag for tiered-pricing is enabled
      case LiteTiered25:
        return isAnnual ? [GrowthTiered25, ProTiered25, EliteTiered25] : [LiteTiered25,GrowthTiered25, ProTiered25, EliteTiered25]
      case GrowthTiered25:
        return isAnnual ? [ProTiered25, EliteTiered25] : [GrowthTiered25, ProTiered25, EliteTiered25]
      case ProTiered25:
        return isAnnual ? [EliteTiered25] : [ProTiered25, EliteTiered25]
      case EliteTiered25:
        return isAnnual ? [] : [EliteTiered25]
      case Lite22:
      case Lite23:
      case FREEMIUM:
      default:
        return isTieredPricingEnabled ? [FREEMIUM,LiteTiered25,GrowthTiered25,ProTiered25,EliteTiered25] : isBilling24Enabled ? [FREEMIUM, (isBilling24V2Enabled ? Lite24V2 : Lite24), Growth24, Pro24, Elite24] : [Lite23, Pro23, Elite23];
    }
  };
};

export const getFilteredPlanNames = createFilteredPlans();
export const initialCardData = {
  nameoncard: '',
  cardType: '',
  expMonth: '',
  expYear: '',
  lastFour: ''
}

// Calculate total savings if user select annual plan based on total savings and no. of active users
export const getTotalSavings = ({planOptions, accountUpgrade}) => {

  if (!planOptions?.length || !accountUpgrade?.activeUsers) {
    return null;  // Return null if no plan options or active users
  }

  const totalSavings = planOptions.reduce((acc, { value, pricing }) => {
    // planOptions 1: Annual plan details
    // planOptions 2: Monthly plan details
    // When user moves from monthly to annual plan, Savings = (Monthly cost * 12) - Annual cost
    const annualizedPricing = value === 'monthly' ? pricing * 12 : pricing * -1;
    return acc + annualizedPricing;
  }, 0);

  const savings = totalSavings * accountUpgrade.activeUsers;
  return savings > 0 ? planChargeInDollars(savings) : null;   // return null in case of no savings
}

export const openCalendlyLink = () => {
  window.open(config.CALENDLY_REDIRECT, '_blank', 'noopener, noreferrer');
}

export const getCurrentTierDetails = (userDetails) => {
    const currentTier = (userDetails.ugDetails || {}).tier;
    const usedSeats = userDetails.ugUserLimit?.used
    const users_bought = (userDetails.ugDetails || {})?.users_bought;
    const userUpperCount = currentTier ? Number(currentTier.split('-')[1]) : null;
    const availableSeats = userUpperCount - usedSeats;
    return {currentTier,usedSeats,users_bought,userUpperCount,availableSeats}
}
